import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faRefresh } from "@fortawesome/pro-regular-svg-icons";

import { Button } from "src/base-components/Button";
import { Icon } from "src/design-system/Icon";

type OverlayProps = {
  icon: IconProp;
  message: string;
  description: string;
  onRetry?: () => void;
};

export const Overlay: React.FC<OverlayProps> = ({
  icon,
  message,
  description,
  onRetry,
}) => {
  return (
    <div className="absolute top-0 left-0 z-10 grid h-full w-full content-center justify-items-center bg-white bg-opacity-80 p-16">
      <div className="mb-4 rounded-lg bg-indigo-100 p-3">
        <Icon icon={icon} size="xs" variant="active" />
      </div>
      <div className="mb-6 max-w-sm text-center">
        <div className="mb-2 font-inter-semibold-13px text-gray-800">
          {message}
        </div>
        <div className="font-inter-normal-12px text-gray-500">
          {description}
        </div>
      </div>
      {onRetry && (
        <Button iconLeft={faRefresh} variant="secondary" onClick={onRetry}>
          Retry
        </Button>
      )}
    </div>
  );
};
